module.exports = __webpack_public_path__ + "img/date-light.3c71efbc.svg";